import React, { useContext, useEffect, useState } from "react";
import { LayoutJournalType, SKJournalArtifact } from "../../../models/SKArtifact";
import { useNavigate } from "react-router-dom";
import { capitalizeFirstLetter } from "../../../utils/stringFunctions";
import { CreateArtifactContext } from "../../../context/CreateArtifactContext";

interface PopoverProps {
  isOpen: boolean;
  onClose: () => void;
}

const types = [
  {
    imgSrc: "/svg/layoutSticky.svg",
    type: LayoutJournalType.stickNotes,
    name: LayoutJournalType.stickNotes,
    redirectURL: "",
  },
  {
    imgSrc: "/svg/layoutDateTime.svg",
    type: LayoutJournalType.dateTime,
    name: LayoutJournalType.dateTime,
    redirectURL: "",
  },
  {
    imgSrc: "/svg/layoutVoiceAudio.svg",
    type: LayoutJournalType.voiceAudio,
    name: LayoutJournalType.voiceAudio,
    redirectURL: "",
  },
  // {
  //   imgSrc: "/svg/layoutDaily.svg",
  //   type: LayoutJournalType.daily,
  //   name: LayoutJournalType.daily,
  //   redirectURL: "",
  // },
  // {
  //   imgSrc: "/svg/layoutWeekly.svg",
  //   type: LayoutJournalType.weekly,
  //   name: LayoutJournalType.weekly,
  //   redirectURL: "",
  // },
];

const SelectJournalLayout = ({ isOpen, onClose }: PopoverProps) => {
  const navigate = useNavigate();
  const [selectedType, setSelectedType] = useState<LayoutJournalType | null>(null);
  const { contentData, artifactId, updateContentData, loading, saveData } = useContext(CreateArtifactContext);
  const handleTypeSelect = (type: LayoutJournalType) => {
    setSelectedType(type);
  };

  useEffect(() => {
    const handleEscKey = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        onClose();
      }
    };

    if (isOpen) {
      document.addEventListener("keydown", handleEscKey);
    }

    return () => {
      document.removeEventListener("keydown", handleEscKey);
    };
  }, [isOpen, onClose]);

  const handleSelect = async () => {
    if (selectedType) {
      updateContentData({
        ...contentData,
        layoutJournal: selectedType,
      } as SKJournalArtifact);
      onClose();
    } else {
      alert("Select type and ");
    }
  };

  return (
    <div className={`fixed z-50 inset-0 flex items-center justify-center ${isOpen ? "visible" : "hidden"}`}>
      <div className="absolute inset-0 bg-black opacity-25"></div>
      <div className="z-10 bg-white rounded-xl shadow-lg max-w-[375px] h-auto w-full overflow-hidden flex flex-col">
        {/* Category Section */}
        <div id="catagory" className="flex-grow-[9] flex-shrink-0 p-[30px] overflow-y-auto">
          <p className="content_title">Choose a Journal Type</p>
          <p className="notes-class-content">Journal entries are displayed based on the type layout.</p>
          <div className="bg-white max-h-[700px] max-w-[375px] mb-[5px] ">
            <div id="ImageArea" className="flex flex-wrap justify-start gap-[15px] align-middle">
              {types.map((data, index) => (
                <div
                  onClick={() => {
                    handleTypeSelect(data.type);
                  }}
                  key={index}
                  className={`flex flex-col text-center w-[150px] h-[150px] items-center mt-[5px] mb-[5px] rounded-xl border-[1px] ${
                    selectedType === data.type ? "border-black border-[2px]" : "border-[#78788033] border-[2px]"
                  }`}
                >
                  <img src={data.imgSrc} alt={data.type} className="h-[150px] w-[150px] rounded-xl border-[1px]" />
                  <span className="pt-[5px] pb-[15px] font-semibold w-full text-left">{capitalizeFirstLetter(data.name)}</span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Separator */}
        <div className="thickseparator h-[2px] bg-gray-300"></div>

        {/* Action Button Section */}
        <div id="actionbtn" className="flex-grow-[1] flex-shrink-0 flex flex-col m-[30px]">
          <div id="action_btn" className="flex items-center justify-between">
            <button
              className="p-2 px-4 w-[113px] h-[46px] text-lg font-normal text-black border-[1px] border-gray-400 border-solid rounded-lg focus:outline-none"
              onClick={onClose}
            >
              Cancel
            </button>
            <button
              className={`px-4 py-2 ml-4  w-[113px] h-[46px] text-lg font-normal text-white rounded-lg shadow focus:outline-none ${
                selectedType ? "bg-black" : "bg-gray-300"
              }`}
              onClick={handleSelect}
              disabled={!selectedType}
            >
              Continue
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default SelectJournalLayout;
